import React from "react";
import "./Loader.css";

export default function Loader(props) {
    return <div className="loader" style={{ width: `${props.size}px`, height: `${props.size}px` }}></div>;
}
